/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Franchise_ListingsInputs */

const cs_franchise_listings = /** @type {(inputs: Franchise_ListingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nabídky`)
};

const en_franchise_listings = /** @type {(inputs: Franchise_ListingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listings`)
};

/**
* | output |
* | --- |
* | "Listings" |
*
* @param {Franchise_ListingsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const franchise_listings = /** @type {((inputs?: Franchise_ListingsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Franchise_ListingsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_franchise_listings(inputs)
	return cs_franchise_listings(inputs)
});